module.exports = __webpack_public_path__ + "img/1.bd31c9d8.jpg";